import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WizardPreviewWrapper } from './styles';

const WizardPreview = (props) => {
  const {
    cableDiameter,
    flagLength,
    withMiddleLine,
    lineType,
    lineThickness,
    middleLineDashed = true,
    withSizes,
    textOrientation,
    slaveAngle,
    isCableFlagSync,
    isDimesionTypeDiameter,
    crossSelectedSection,
    isFlagLengthAuto
  } = props;

  let _slaveAngle = textOrientation === 'vertical'? 270 + Number(slaveAngle) : Number(slaveAngle);
  const transformTextL = "rotate(" + _slaveAngle + ")";
  const transformTextR = textOrientation === 'vertical'? 'rotate(270)' : '';
  const strokeDasharray = lineType === 'dashed' ? { strokeDasharray: middleLineDashed ? '6 2' : '6 0' } : {  };

  const textAuto = <FormattedMessage id="app.editor.wizard.form.auto" defaultMessage="Auto" />;
  return (
    <WizardPreviewWrapper>
        <svg width="530" height="242" viewBox="0 0 45 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="wizard" transform='scale(0.8)'>
          <g id="rect-left" transform='translate(-240, 32)'>
            <path d="M240 69.958v-6.083h-.5v-6.083h.5v-6.084h-.5v-6.083h.5v-6.083h-.5v-6.084h.5v-6.083h-.5v-6.083h.5v-6.084h-.5V9.125h.5V3.042h-.5V.5H237V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5h-6V0h-6v.5H9V0H3v.5H.5v2.542H0v6.083h.5v6.083H0v6.084h.5v6.083H0v6.083h.5v6.084H0v6.083h.5v6.083H0v6.084h.5v6.083H0v6.083h.5V72.5H3v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h6v.5h6v-.5h2.5v-2.542h.5z" fill="#fff" stroke="#A6A6A6" strokeDasharray="6 6"/>
            <g id="text-l" transform='translate(120, 36)'>
              <text x="0" y="0"
                className="svg-text-normal"
                textAnchor="middle"
                alignmentBaseline="central"
                fontSize="18"
                fill="#636363"
                transform={transformTextL}>{isCableFlagSync? 'Text 1' : 'Text 2'}</text>
            </g>
          </g>

          <g id="rect-right" transform='translate(41, 32)'>
            <path d="M232.718 8.65 1.41 4 .483 74.145l231.221 4.649 1.014-70.144z" fill="url(#w6bgl77i7a)"/>
            <path d="M244 0H4l.09 74H244V0z" fill="url(#1ujwpgzh8b)"/>
            <path opacity=".8" fill="url(#w43lbbp9tc)" d="M4 0h87v74H4z"/>
            <defs>
                <linearGradient id="w6bgl77i7a" x1="155.163" y1="38.514" x2="244.141" y2="70.755" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#BCBCBC"/>
                    <stop offset="1" stopColor="#EBEBEB"/>
                </linearGradient>
                <linearGradient id="1ujwpgzh8b" x1="32.5" y1="5" x2="248.5" y2="71.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EBEBEB"/>
                    <stop offset="1" stopColor="#F3F3F3"/>
                </linearGradient>
                <linearGradient id="w43lbbp9tc" x1="-.833" y1="0" x2="68" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#A6A6A6"/>
                    <stop offset=".787" stopColor="#A6A6A6" stopOpacity="0"/>
                </linearGradient>
            </defs>
            <g id="text-r" transform='translate(120, 36)'>
              <text x="0" y="0"
                className="svg-text-normal"
                textAnchor="middle"
                alignmentBaseline="central"
                fontSize="18"
                fill="#636363"
                transform={transformTextR}>Text 1</text>
            </g>
          </g>

          <g id="cable-group" transform='translate(-3, 0)'>
            <path fillRule="evenodd" clipRule="evenodd" d="M24 111.998V93.002c-12.748.108-23 4.319-23 9.498 0 5.179 10.252 9.39 23 9.498z" fill="#898989"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M4 124.266V1.763C4 .79 5.53 0 7.417 0h34.166C43.47 0 45 .79 45 1.763v122.503c0 .973-1.53 1.762-3.416 1.762H7.416c-1.886 0-3.417-.789-3.417-1.762z" fill="#A6A6A6"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M33.241 183h1.509c1.886 0 3.416-1.547 3.416-3.453v-6.996L33.242 183zM23.78 183h5.677l8.709-18.476V152.48L23.78 183zM14.318 183h5.677l18.171-38.547v-8.066c0-.853-.317-1.621-.825-2.227L14.318 183zM10.834 170.323v9.224c0 .651.188 1.246.495 1.766l22.806-48.379H28.46l-17.625 37.389zM10.833 150.252v12.045l13.841-29.362h-5.678l-8.163 17.317zM15.212 132.934h-.962c-1.886 0-3.417 1.546-3.417 3.452v5.837l4.379-9.289z" fill="#D2D2D2"/>
            <g style={{ mixBlendMode: 'multiply' }} filter="url(#nifloqyl7a)">
                <path fillRule="evenodd" clipRule="evenodd" d="M44.981 104a6.59 6.59 0 0 0 .019-.5C45 97.149 35.822 92 24.5 92S4 97.149 4 103.5c0 .168.006.334.019.5.467-6.12 9.458-11 20.481-11 11.023 0 20.014 4.88 20.481 11z" fill="#000"/>
            </g>
            <path fillRule="evenodd" clipRule="evenodd" d="M47.988 32.844c.007-.114.01-.229.01-.344 0-2.698-1.899-5.18-5.079-7.142-1.84-1.262-4.348-2.392-7.76-3.11-3.2-.798-6.822-1.248-10.66-1.248C11.521 21 1 26.149 1 32.5c0 .093.002.185.007.278-.008.144-.003.223-.003.223v69.293a5.712 5.712 0 0 0 0 .412v.295s0-.049.007-.139l.01.138c.312-3.561 3.933-6.703 9.398-8.708 3.538-1.214 8.407-2.111 15.106-2.281 11.233.236 20.423 4.331 22.173 9.645.102.353.181.696.242 1.023.015.107.027.214.037.321l.005-.071.02.129V106s.252-1.221 0-2.942V33.001s-.002-.055-.014-.157z" fill="url(#g435iw03hb)"/>
            <mask id="l5ypu5b1oc" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="1" y="21" width="47" height="83">
                <path fillRule="evenodd" clipRule="evenodd" d="M47.977 32.844a5.78 5.78 0 0 0 .01-.344c0-2.698-1.898-5.18-5.078-7.142-1.84-1.262-4.346-2.392-7.758-3.11C31.952 21.45 28.33 21 24.494 21 11.518 21 1 26.149 1 32.5c0 .093.002.186.007.278-.008.144-.003.223-.003.223v69.292a5.763 5.763 0 0 0 0 .414v.294s0-.053.007-.151l.01.15c.536-6.12 10.84-11 23.473-11s22.937 4.88 23.472 11a5.732 5.732 0 0 0 .021-.577l.004.064v.514s.02-.187 0-.514V33.001s-.002-.055-.014-.157z" fill="#E9E9E9"/>
            </mask>
            <g mask="url(#l5ypu5b1oc)">
                <g filter="url(#yeov8qc8gd)">
                    <path fill="#fff" d="M11.51 21h9.656v76H11.51z"/>
                </g>
                <g filter="url(#qv8i0bzppe)">
                    <path fill="#fff" d="M15.802 21h3.219v76h-3.219z"/>
                </g>
                <path opacity=".7" transform="matrix(-1 0 0 1 47.988 21)" fill="url(#yu9zk5wuqf)" d="M0 0h22.531v82H0z"/>
            </g>
            <defs>
                <filter id="nifloqyl7a" x="0" y="88" width="49" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_755_48383"/>
                </filter>
                <filter id="yeov8qc8gd" x="1.51" y="11" width="29.656" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_755_48383"/>
                </filter>
                <filter id="qv8i0bzppe" x="7.802" y="13" width="19.219" height="92" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_755_48383"/>
                </filter>
                <linearGradient id="g435iw03hb" x1="15.939" y1="62" x2="68.097" y2="63.543" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E9E9E9"/>
                    <stop offset="1" stopColor="#fff"/>
                </linearGradient>
                <linearGradient id="yu9zk5wuqf" x1="-1.252" y1="0" x2="22.531" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#A6A6A6"/>
                    <stop offset="1" stopColor="#A6A6A6" stopOpacity="0"/>
                </linearGradient>
            </defs>
          </g>

          {withMiddleLine && (
            <g id="cable-middle-line">
              <line x1="21" y1="22" x2="21" y2="93" stroke="#000000" {...strokeDasharray} strokeWidth={lineThickness}></line>
            </g>
          )}
          {
            withSizes && (
              <>
                <g id="group-16" transform='translate(0, 193)'>
                  <path d="M1 0v7h42V0" stroke="#636363"/>
                </g>
                <g id="group-17" transform='translate(44, 193)'>
                  <path d="M1 0v7h235V0" stroke="#636363"/>
                </g>
                <g id="group-216" transform='translate(11, 193)'>
                  {
                    isDimesionTypeDiameter && (
                      <>
                      <circle cx="10" cy="7" r="5.567" fill="#fff" stroke="#636363"/>
                      <path d="M10 13.988a6.804 6.804 0 0 1-2.725-.55 7.057 7.057 0 0 1-2.219-1.494 7.058 7.058 0 0 1-1.493-2.219A6.804 6.804 0 0 1 3.013 7c0-.967.183-1.875.55-2.725.367-.85.865-1.59 1.493-2.219A7.057 7.057 0 0 1 7.275.563 6.804 6.804 0 0 1 10 .013c.967 0 1.875.183 2.725.55.85.367 1.59.865 2.219 1.493a7.057 7.057 0 0 1 1.493 2.219c.367.85.55 1.758.55 2.725 0 .967-.183 1.875-.55 2.725a7.058 7.058 0 0 1-1.493 2.219 7.058 7.058 0 0 1-2.219 1.493c-.85.367-1.758.55-2.725.55zm0-1.375c1.567 0 2.894-.544 3.981-1.632C15.07 9.894 15.613 8.567 15.613 7c0-1.567-.544-2.894-1.632-3.981C12.894 1.93 11.567 1.387 10 1.387c-1.567 0-2.894.544-3.981 1.632C4.93 4.106 4.388 5.433 4.388 7c0 1.567.543 2.894 1.63 3.981C7.107 12.07 8.434 12.613 10 12.613z" fill="#636363" stroke="#636363" strokeWidth=".025"/>
                      <path d="M1 12 18.32 2" stroke="#636363" strokeWidth="2"/>
                      </>
                    )
                  }
                  <text x="10" y="40" className='svg-text-small' textAnchor="middle" fontSize="18" fill="#636363">{isDimesionTypeDiameter? cableDiameter : crossSelectedSection?.label}</text>
                </g>
                <g id="group-217" transform='translate(152, 193)'>
                  <path fill="#fff" stroke="#636363" d="M2.5 2.5h15v7h-15z"/>
                  <path d="M1.988 10v.012h16.024V1.988h-3.024v3.999h-1.976V1.988h-2.024v3.999H9.012V1.988H6.987v3.999H5.013V1.988H1.988V10zM2 11.988a1.914 1.914 0 0 1-1.404-.584A1.914 1.914 0 0 1 .012 10V2c0-.547.195-1.014.584-1.404C.986.207 1.453.012 2 .012h16c.547 0 1.014.195 1.404.584.389.39.584.857.584 1.404v8c0 .547-.195 1.014-.584 1.404-.39.389-.857.584-1.404.584H2z" fill="#636363" stroke="#636363" strokeWidth=".025"/>
                  <text x="10" y="40" className='svg-text-small' textAnchor="middle" fontSize="18" fill="#636363">{isFlagLengthAuto? textAuto : flagLength}</text>
                </g>
              </>
            )
          }
        </g>
      </svg>
    </WizardPreviewWrapper>
  );
};

export default React.memo(WizardPreview);
